var Search = {};
Search.init = function () {
  var searchOpen = $('.js-search-open');
  var searchClose = $('.js-search-close');
  var searchForm = $('.js-search-form');
  searchOpen.on('click', function () {
    searchForm.addClass('show');
    var targetEl = $($(this).data('focus'));
    if (targetEl) {
      setTimeout(function () {
        targetEl.focus();
      }, 100);
    }
  });
  searchClose.click(function () {
    searchForm.removeClass('show');
  });
};
Search.init();


// WEBPACK FOOTER //
// ./scripts/components/search.js